import { NotificationManager } from "react-notifications";

const uri = process.env.API_REST_PROFILE_PHOTOS;

export async function getListProfilePhotos(id) {
  try {
    const response = await fetch(`${uri}/getresources?resourceId=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json(); // Parse the JSON response
    return data;
  } catch (error) {
    console.error("Error in downloading", error);
    const errorMessage = error.message.split("\n")[0];
    NotificationManager.error(errorMessage, "", 5000);
    throw error; // Re-throw the error for further handling, if needed
  }
}

export async function getProfilePhotoByName(id, name) {
  try {
    const response = await fetch(`${uri}/getresources?resourceId=${id}&filename=${name}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json(); // Parse the JSON response
    return data;
  } catch (error) {
    console.error("Error in downloading", error);
    const errorMessage = error.message.split("\n")[0];
    NotificationManager.error(errorMessage, "", 5000);
    throw error; // Re-throw the error for further handling, if needed
  }
}





